<template>
  <div style="margin-bottom: 500px">
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab v-for="(item, i) in items" :key="item.id">
        <v-icon class="mr-2">{{ item.icon }}</v-icon>
        {{ translate(item.tab) }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(item, i) in items" :key="item.id">
        <component v-if="tab === i" :is="item.component" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import CompanyReportTabEmployees from "@/components/company/reports/companyTabs/companyReportTabEmployees.vue";
import CompanyReportTabMeals from "@/components/company/reports/companyTabs/companyReportTabMeals.vue";
import CompanyReportTabMealEmployees from "@/components/company/reports/companyTabs/companyReportTabMealEmployees.vue";
import CompanyReportTabTakenMeals from "@/components/company/reports/companyTabs/companyReportTabTakenMeals.vue";
import CompanyReportTabTaken from "@/components/company/reports/companyTabs/CompanyReportTabTaken.vue";
import CompanyReportTabOrders from "@/components/company/reports/companyTabs/companyReportTabOrders.vue";
import CompanyReportTabTakenCompany from "@/components/company/reports/companyTabs/CompanyReportTabTakenCompany.vue";
import CompanyReportTabReservedMeals from "@/components/company/reports/companyTabs/companyReportTabReservedMeals.vue";

export default {
  name: "CompanyReports",
  data: () => ({
    tab: null,
  }),
  methods: {
    getReport() {
      // Logic to fetch the report based on selected companies and dates
    },
  },
  computed: {
    items() {
      return [
        {
          id: 1,
          tab: this.$t("meals"),
          icon: "mdi-clipboard-list-outline",
          component: CompanyReportTabMeals,
        },
        {
          id: 2,
          tab: this.$t("meal_worker"),
          icon: "mdi-format-list-bulleted-type",
          component: CompanyReportTabMealEmployees,
        },
        {
          id: 3,
          tab: this.$t("employees"),
          icon: "mdi-account-settings",
          component: CompanyReportTabEmployees,
        },
        {
          id: 4,
          tab: "Преузети оброци",
          component: CompanyReportTabTakenMeals,
          icon: "mdi-check-underline-circle",
        },
        {
          id: 5,
          tab: this.$t("taken"),
          component: CompanyReportTabTaken,
          icon: "mdi-truck-delivery",
        },
        {
          id: 6,
          tab: "Preuzeto kompanija",
          component: CompanyReportTabTakenCompany,
          icon: "mdi-truck-delivery",
        },
        {
          id: 7,
          tab: this.$t("ordered_1"),
          icon: "mdi-grid",
          component: CompanyReportTabOrders,
        },
        {
          id: 8,
          tab: this.$t("r_o"),
          icon: "mdi-food-variant",
          component: CompanyReportTabReservedMeals,
        },
      ];
    },
  },
  watch: {
    selectedCompanies() {
      this.getReport();
    },
    dates() {
      this.getReport();
    },
  },
};
</script>
